import React, { useState,useEffect } from 'react';
import Divider from '@mui/joy/Divider';
import "../sample/global.scss";
import { labelValue } from '../Helpers';

    interface PlanningBoxProps {
        title: string;
        project: {
            startDate: string;
            endDate: string;
        };
    }
    
    const PlanningBox = ({ title, project }: PlanningBoxProps) => {
        const [startDate, setStartDate] = useState<string>('');
        const [endDate, setEndDate] = useState<string>('');

        useEffect(() => {
            const startDate = new Date(project?.startDate);
            const endDate = new Date(project?.endDate);
            setStartDate(startDate.toLocaleDateString());
            setEndDate(endDate.toLocaleDateString());
        }, [project]);

    return (
        <div className='box'>
            <h2>{title}</h2>
            <div className='items'>

                {labelValue(startDate, "Startdatum")}
                {labelValue(endDate, "Einddatum")}
            </div>
        </div>
    );
};

export default PlanningBox;
